import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import CurrencyInput from 'react-currency-input-field';
import swal from '@sweetalert/with-react';
import dateFormater from '../Classes/FormatDate'
import formatTime from '../Classes/FormatTime';
import { saveBGDraftDocDetail, UpdateBgGraftDocDetail, GetBGDraftDocDetail, GetPODetailDocDetail, savePOBGDraftDocDetail, GetBgDraftDocTableData, UpdatePOBGDraftDocDetail, getactionDetail, } from '../store/actions/BGDraftDocAction'
import { uploadFileGeneric, GenericUploadVersionFile } from '../store/actions/fileActions'
import { GetFilterList } from '../store/actions/masterActions'
import numberWithCommas from '../Classes/NumberwithComma'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Select, { components } from "react-select"
import AuthHandler from '../Classes/AuthHandler'
import env from '../ENV';
import Papa from 'papaparse';
import FileVersionModal from '../Components/FileVersionModal';
import Loading from '../Components/Loader';
// import { CSVLink } from "react-csv";
import SearchBar from '../Components/SearchBar'
import toast from 'react-hot-toast';
import { Form, Button, InputGroup, FormControl, Card } from 'react-bootstrap';
import { getProjectAllocationByUserId } from '../store/actions/poDetailsActions';

const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}
function getDifferenceInDays(dateVal) {
    let today = new Date();
    let DateVal = new Date(dateVal)
    const diffInMs = Math.abs(DateVal - today);
    return Math.round(diffInMs / (1000 * 60 * 60 * 24));
}
class BGDraftDoc extends Component {
    constructor() {
        super();
        this.state = {
            pdfFile: [],
            POpdfFile: [],
            RevisePOpdfFile: [],
            dropDownArray: [],
            BlankDocumentID: "",
            tableData: [],
            selectedPOSAPId: null,
            BGType: "",
            BGTypeOption: [{ label: "ABG", value: 'ABG' },
            { label: "PBG", value: 'PBG' },
            ],
            bgUploadDocumentmodal: false,
            loadingData: false,
            OpenVersionmodal: false,
            OpenInFoModal: false,
            BGAvtivityModal: false,
            BGReviseAvtivityModal: false,
            ActivityComment: "",
            BGActivityaction: "",
            BgActivitystatus: "",
            selectedBGPORow: {},
            uploadedId: 0,
            err: {},
            bgStatus: {
                1: { title: "Document is Approved", badge: "badge-success", status: "Approved" },
                2: { title: "Revise Document Uploaded", badge: "badge-warning", status: "Revise Document Uploaded" },
                3: { title: "Document is Rejected", badge: "badge-danger", status: "Rejected" },
                0: { title: "Document Uploaded", badge: "badge-warning", status: "Document Uploaded" },
                null: { title: "Document to be Submitted", badge: "badge-warning", status: "" },
            },
        }
    }
    componentDidMount = async () => {
        let roles = AuthHandler.getRoles()
        let userId = AuthHandler.getUserID()
        await this.dataSync()
    }
    dataSync = async () => {
        this.setState({ loadingData: true })
        await this.props.GetBGDraftDocDetail()
        await this.props.GetPODetailDocDetail(AuthHandler.getUserID())
        await this.props.GetBgDraftDocTableData(AuthHandler.getUserID(), AuthHandler.getGroups())
        const PoDetail = this.props.bgdraftDocReducer?.poDetail || [];
        const poOptionArray = PoDetail.map(item => ({
            label: item.POSAPId,
            value: item.PurchaseOrderId,
        }));
        let tableData = this.props.bgdraftDocReducer?.BGDocTable || null;
        let BlankDocumentID = this.props.bgdraftDocReducer && this.props.bgdraftDocReducer.bgDraftGet && this.props.bgdraftDocReducer.bgDraftGet.length > 0 ? this.props.bgdraftDocReducer.bgDraftGet[0].DocumentId : ""
        console.log(poOptionArray, "jdnjflnsdjnfjlsdf")
        await this.setState({
            pdfFile: [], selectedPOSAPId: null, BGType: "", loadingData: false, BlankDocumentID: BlankDocumentID, tableData: tableData, dropDownArray: poOptionArray, ActivityComment: "", OpenVersionmodal: false,
            BGReviseAvtivityModal: false, BGAvtivityModal: false, BGActivityaction: "",
            BgActivitystatus: "",
            OpenInFoModal: false,
            selectedBGPORow: {},
            uploadedId: 0,
        })
    }
    //Open Modal-------------------
    handlePDF = async (event) => {
        var regex = /jpeg|jpg|png|gif|pdf|zip|rar|xls|docx|pptx|mp4|avi|mkv|xlsx/;
        if (!(regex.test(event.target.value.toLowerCase()))) {
            event.target.value = '';
            swal("Please upload the file you have downloaded from the system", { icon: "error" })
            return false
        }
        let pdfFile = [event.target.files[0]]
        await this.setState({ pdfFile })
        console.log("Files-data", this.state.pdfFile)
    }
    uploadPDF = async () => {
        var result;
        if (this.state.pdfFile.length == 0) {
            swal("Please select a file to upload", { icon: "error" })
            return false
        }
        if (this.state.BlankDocumentID) {
            result = await this.props.GenericUploadVersionFile(this.state.pdfFile, this.state.BlankDocumentID, "", AuthHandler.getUserID());
            console.log(this.state.BlankDocumentID, result, "sjdhbfhsbdhfsjdbfjs")
            if (result.results[0]) {
                console.log("sdkfdsbfbsdkfbdskj")
                await this.props.UpdateBgGraftDocDetail(result.results[0], AuthHandler.getUserID())
                await this.dataSync()
                await this.bgUploadDocumentmodal()
            }
        }
        else{
            result = await this.props.uploadFileGeneric(this.state.pdfFile, AuthHandler.getUserID())
            if (result.results[0]) {
                console.log("sdkfdsbfbsdkfbdskj-----")
                await this.props.saveBGDraftDocDetail(result.results[0], AuthHandler.getUserID())
                console.log(this.props, "sdkhbfhsdbhfkdbfksd")
                await this.dataSync()
                await this.bgUploadDocumentmodal()
            }
        }

       

    }

    bgUploadDocumentmodal() {
        console.log(this.state.bgUploadDocumentmodal, "sljdnfjnsdjfnjsdnfj")
        this.setState({ bgUploadDocumentmodal: !this.state.bgUploadDocumentmodal });
        console.log(this.state.bgUploadDocumentmodal, "sljdnfjnsdjfnjsdnfj---")
        if (this.state.bgUploadDocumentmodal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    handleSelectBGType = async (e) => {
        this.setState({ loading: true })
        let BGType = e.value
        await this.setState({ BGType: BGType })
    }

    handleSelectPOs = async (e) => {
        this.setState({ loading: true })
        console.log(e, "fkgbjkdfnjgdkfgkjbdf")
        let selectedPOSAPId = e.value
        await this.setState({ selectedPOSAPId: selectedPOSAPId })
    }

    handlePOPDF = async (event) => {
        var regex = /jpeg|jpg|png|gif|pdf|zip|rar|xls|docx|pptx|mp4|avi|mkv|xlsx/;
        if (!(regex.test(event.target.value.toLowerCase()))) {
            event.target.value = '';
            swal("Please upload the file you have downloaded from the system", { icon: "error" })
            return false
        }
        let POpdfFile = [event.target.files[0]]
        await this.setState({ POpdfFile })
        console.log("Files-data", this.state.POpdfFile)
    }

    uploadPOPDF = async () => {
       this.setState({ loadingData: true })
        let err = {}

        let tabledata = this.props.bgdraftDocReducer?.BGDocTable || null
        err.POAsId = this.state.selectedPOSAPId != null ? "" : "Mandatory Field"
        err.BGtype = this.state.BGType != "" ? "" : "Mandatory Field"
        err.fileerr = this.state.POpdfFile.length > 0 && this.state.POpdfFile != null ? "" : "Mandatory Field"
        await this.setState({ err })

        if (Object.keys(err).length) {
            const isEmpty = Object.values(err).every((x) => x === "");
            console.log(isEmpty, "rcc");
            if (isEmpty === true) {
                let recordpresent = tabledata.some(item => item.PurchaseOrderID == this.state.selectedPOSAPId && item.BgType == this.state.BGType);
                if (recordpresent) {
                    swal("Please check a record for this PO Number and BGtype already present", { icon: "error" })
                    await this.dataSync()
                    return false;
                }
                
                var result = await this.props.uploadFileGeneric(this.state.POpdfFile, AuthHandler.getUserID())

                if (result.results[0]) {
                    console.log("sdkfdsbfbsdkfbdskj")
                    let action = "New BG Draft Uploaded By Suplier";
                    let status = 0
                    await this.props.savePOBGDraftDocDetail(result.results[0], AuthHandler.getUserID(), this.state.selectedPOSAPId, this.state.BGType, action, status, AuthHandler.getUserPayLoad().fullName)
                    console.log(this.props, "sdkhbfhsdbhfkdbfksd")
                    await this.dataSync()
                    await this.setState({ loadingData: false })
                }
            }
            else{
                this.setState({ loadingData: false })  
            }
        }
    }

    handleRevisePDF = async (event) => {
        var regex = new RegExp("(.*?)\.(pdf)$");
        if (!(regex.test(event.target.value.toLowerCase()))) {
            event.target.value = '';
            swal("Please upload the file you have downloaded from the system", { icon: "error" })
            return false
        }
        let RevisePOpdfFile = [event.target.files[0]]
        await this.setState({ RevisePOpdfFile })
        console.log("Files-data", this.state.RevisePOpdfFile)
    }

    async handleBGReviseActivity(item) {
        this.setState({ loadingData: true })
        let err = {}

        err.comment = this.state.ActivityComment != null ? "" : "Mandatory Field"
        err.revisefile = this.state.RevisePOpdfFile.length > 0 && this.state.RevisePOpdfFile != null ? "" : "Mandatory Field"
        await this.setState({ err })

        if (Object.keys(err).length) {
            const isEmpty = Object.values(err).every((x) => x === "");
            console.log(isEmpty, "rcc");
            if (isEmpty === true) {
                if (!this.state.BGActivityaction && this.state.BGActivityaction != "") {
                    swal("failed to load action", { icon: "error" })
                    await this.dataSync()
                    return false;
                }
                if (!this.state.BgActivitystatus) {
                    swal("failed to load status", { icon: "error" })
                    await this.dataSync()
                    return false;
                }

                let action = this.state.BGActivityaction
                let status = this.state.BgActivitystatus

                if (item.DocumentID != 0) {
                    toast.loading('Uploading Files...', {
                        duration: 1000
                    });
                    await this.props.GenericUploadVersionFile(this.state.RevisePOpdfFile, item.DocumentID, this.state.ActivityComment, AuthHandler.getUserID());
                }
                console.log("sdkjfjsndjnkjskdf")
                console.log(AuthHandler.getUserID(), item, action, status, this.state.ActivityComment, "sdkjbfkbhdsfbksbfd")
                await this.props.UpdatePOBGDraftDocDetail(AuthHandler.getUserID(), item, action, status, this.state.ActivityComment, AuthHandler.getUserPayLoad().fullName)
                console.log(this.props, "sdkhbfhsdbhfkdbfksd")
                // await this.RevisemodalBGActivity(this.state.selectedBGPORow)
                await this.dataSync()
                await this.setState({ loadingData: false })
            }
        }
    }

    async handleBGActivity(item) {
        let err = {}
        
        err.comment = this.state.ActivityComment != null ? "" : "Mandatory Field"
        await this.setState({ err })
        
        if (Object.keys(err).length) {
            const isEmpty = Object.values(err).every((x) => x === "");
            console.log(isEmpty, "rcc");
            if (isEmpty === true) {
                if (!this.state.BGActivityaction && this.state.BGActivityaction != "") {
                    swal("failed to load action", { icon: "error" })
                    await this.dataSync()
                    return false;
                }
                if (!this.state.BgActivitystatus) {
                    swal("failed to load status", { icon: "error" })
                    await this.dataSync()
                    return false;
                }
                this.setState({ loadingData: true })
                let action = this.state.BGActivityaction
                let status = this.state.BgActivitystatus
                console.log(AuthHandler.getUserID(), item, action, status, this.state.ActivityComment, "sdkjbfkbhdsfbksbfd")
                await this.props.UpdatePOBGDraftDocDetail(AuthHandler.getUserID(), item, action, status, this.state.ActivityComment, AuthHandler.getUserPayLoad().fullName)
                console.log(this.props, "sdkhbfhsdbhfkdbfksd")
                this.RevisemodalBGActivity(this.state.selectedBGPORow)
                await this.dataSync()
                await this.setState({ loadingData: false })
            }
        }
    }

    async OpenVersionModal(uploadedId) {
        let versionList = [];
        console.log(uploadedId, "this.state.uploadID")
        let stateVal = this.state.OpenVersionmodal;
        this.setState({ OpenVersionmodal: !stateVal, uploadedId: uploadedId });
    }

    async OpenInFoModal(item) {
        console.log(item, "this.state.uploadID")
        await this.props.getactionDetail(item)
        console.log(this.props.bgdraftDocReducer, "sdkhfbkhsdbfkbdskjfbksbdf")

        if (this.props.bgdraftDocReducer && this.props.bgdraftDocReducer.pobgDraftAction && this.props.bgdraftDocReducer.pobgDraftAction.length > 0) {
            let stateVal = this.state.OpenInFoModal;
            this.setState({ OpenInFoModal: !stateVal, selectedBGPORow: item });
        }
        else {
            swal("failed to load action table", { icon: "error" })
            await this.dataSync()
            return false;
        }

    }

    async modalBGActivity(item, action, status) {
        let rowdata = item
        let stateVal = this.state.BGAvtivityModal;
        this.setState({ BGAvtivityModal: !stateVal, selectedBGPORow: rowdata, BGActivityaction: action, BgActivitystatus: status });
    }

    async RevisemodalBGActivity(item, action, status) {
        let rowdata = item
        let stateVal = this.state.BGReviseAvtivityModal;
        this.setState({ BGReviseAvtivityModal: !stateVal, selectedBGPORow: rowdata, BGActivityaction: action, BgActivitystatus: status });
    }

    async handlecomment(e) {

        this.setState({ ActivityComment: e });
    }

    render() {
        var groups = AuthHandler.getGroups()
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                //   color: state.isSelected ? 'red' : 'blue',
                padding: "2px 10px",
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
        }
        return (
            this.state.loadingData == true ?
                <Loading />
                :
                <div style={{ marginBottom: '3%' }}>
                    {/*----------File version start  */}
                    {this.state.uploadedId && this.state.OpenVersionmodal ? <FileVersionModal OpenVersionmodal={this.state.OpenVersionmodal} uploadedId={this.state.uploadedId} OpenVersionModal={(uploadId) => this.OpenVersionModal(uploadId)} /> : null}
                    {/*----------File version end  */}
                    {/* BG Activity MODAL starts */}
                    <Modal isOpen={this.state.BGAvtivityModal} >
                        <div className={"modal-bg" + (this.state.BGAvtivityModal === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div><h4 > {this.state.BgActivitystatus == 1 ? "Approve Draft BG" : this.state.BgActivitystatus == 3 ? "Reject Draft BG" : "Upload BG"} </h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={() => { this.modalBGActivity(this.state.selectedBGPORow) }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div >
                                <ModalBody Style="modal-body">
                                    <div className="row ml-2 pt-2" style={{ display: 'flex', flexDirection: 'column' }}>
                                        <p>PO : {this.state.selectedBGPORow.POSAPId}</p>
                                        <p>BGType : {this.state.selectedBGPORow.BgType}</p>
                                        <div className="col-md-5"><b>Comment :</b></div>
                                        <div className="col-md-7">
                                            <input type="text" id='BGUpload' onChange={(e) => this.handlecomment(e.target.value)} />
                                            {this.state.err.comment != "" ? <p style={{ color: 'red', fontSize: '10px' }}>{this.state.err.comment}</p> : null}
                                        </div>
                                    </div>
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer">
                                    <div>
                                        <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.modalBGActivity(this.state.selectedBGPORow) }} type="submit">Cancel</button>
                                        <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.handleBGActivity(this.state.selectedBGPORow)} type="submit">Submit</button>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                    {/* BG Revise Activity MODAL ENDS */}
                    {/* BG Activity MODAL starts */}
                    <Modal isOpen={this.state.BGReviseAvtivityModal} >
                        <div className={"modal-bg" + (this.state.BGReviseAvtivityModal === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div><h4 > {this.state.BgActivitystatus == 1 ? "Approve Draft BG" : this.state.BgActivitystatus == 3 ? "Reject Draft BG" : "Upload BG"} </h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={() => { this.RevisemodalBGActivity(this.state.selectedBGPORow) }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div >
                                <ModalBody Style="modal-body">
                                    <div className="row ml-2 pt-2" style={{ display: 'flex', flexDirection: 'column' }}>
                                        <p>PO : {this.state.selectedBGPORow.POSAPId}</p>
                                        <p>BGType : {this.state.selectedBGPORow.BgType}</p>
                                        <div className="col-md-5"><b>Comment :</b></div>
                                        <div className="col-md-7">
                                            <input type="text" id='BGUpload' onChange={(e) => this.handlecomment(e.target.value)} />
                                            {this.state.err.comment != "" ? <p style={{ color: 'red', fontSize: '10px' }}>{this.state.err.comment}</p> : null}
                                        </div>
                                        <div className="col-md-5"><b>Select file to revise :</b></div>
                                        <div className="col-md-7">
                                            <input type="file" id='BGUpload' onChange={(e) => this.handleRevisePDF(e)} />
                                            {this.state.err.revisefile != "" ? <p style={{ color: 'red', fontSize: '10px' }}>{this.state.err.revisefile}</p> : null}
                                        </div>
                                    </div>
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer">
                                    <div>
                                        <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.RevisemodalBGActivity(this.state.selectedBGPORow) }} type="submit">Cancel</button>
                                        <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.handleBGReviseActivity(this.state.selectedBGPORow)} type="submit">Submit</button>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                    {/* BG Revise Activity MODAL ENDS */}
                    {/* BG Action Modal starts */}
                    <Modal isOpen={this.state.OpenInFoModal} className="modal-xl mr-2">
                        <div className={"modal-bg" + (this.state.OpenInFoModal === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div><h4 >Activity Details : {this.state.selectedBGPORow.POSAPId}</h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={() => { this.OpenInFoModal(this.state.selectedBGPORow) }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div >
                                <ModalBody Style="modal-body">
                                    <div className="row">
                                        <div className="col">
                                            <table border="1" className="table5 table" >
                                                <thead>
                                                    <tr className="headerbar ">
                                                        <th>Action</th>
                                                        <th>Acted By</th>
                                                        <th>Acted On</th>
                                                        <th>Acted Time</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.props.bgdraftDocReducer.pobgDraftAction && this.props.bgdraftDocReducer.pobgDraftAction.length > 0 && this.props.bgdraftDocReducer.pobgDraftAction.map((item, index) =>
                                                        <tr key={index} className="rows headeralign">
                                                            <td>{item.ActionName}</td>
                                                            <td>{item.FullName}</td>
                                                            <td>{item.CreatedOn ? dateFormater(item.CreatedOn) : '----'}</td>
                                                            <td>{item.CreatedOn ? formatTime(item.CreatedOn) : '----'}</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </ModalBody>
                            </div>
                        </div>
                    </Modal>
                    {/* BG Revise Action Modal ENDS */}
                    {/* BG BULK Upload MODAL starts */}
                    <Modal isOpen={this.state.bgUploadDocumentmodal} >
                        <div className={"modal-bg" + (this.state.bgUploadDocumentmodal === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div><h4 >Add Draft BG </h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={() => { this.bgUploadDocumentmodal() }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div >
                                <ModalBody Style="modal-body">
                                    <div className="row ml-2 pt-2">
                                        <div className="col-md-5"><b>Upload New Draft BG File :</b></div>
                                        <div className="col-md-7">
                                            <input type="file" id='BGUpload' onChange={(e) => this.handlePDF(e)} />
                                        </div>
                                    </div>
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer">
                                    <div>
                                        <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.bgUploadDocumentmodal() }} type="submit">Cancel</button>
                                        <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.uploadPDF()} type="submit">Upload</button>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                    {/* BG BULK Upload MODAL ENDS */}
                    <div>
                        <div className='row pl-5 pt-3 pr-4'>
                            <div className='col-6'></div>
                            <div className='col-6'>
                            </div>
                        </div>
                        <div className="row pl-5 pt-2">
                            <div className='col'><h2>DRAFT BANK GUARANTEES </h2></div>
                            <div className='col'>
                                <div className='float-right' style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row-reverse'}}>
                                    {this.state.BlankDocumentID ? <a href={FILESERVER_ROOT_URL + "files/Documents/" + this.state.BlankDocumentID + "/download"} target="_blank" download className='btn2 btn-sms1 rounded-pill float-right'>Download Draft BG</a> : ""}
                                    {groups[9] ? <button className="btn2 btn-sms1 rounded-pill float-right" onClick={() => this.bgUploadDocumentmodal()}>Upload Draft BG</button> : null}
                                    {groups[9] && this.state.BlankDocumentID ? <div className='btn2 btn-sms1 rounded-pill' style={{marginRight: '10px', marginTop: '5px'}} onClick={() => this.OpenVersionModal(this.state.BlankDocumentID)}><FontAwesomeIcon icon={"code-branch"} cursor="pointer" color={"white"} title="History" size="lg" /></div> : null}
                                </div>

                            </div>
                        </div>
                        {groups[6] ?
                            <div className="row pl-5 pt-6">
                                <div style={{ height: '6rem', width: '95%', borderRadius: '5px', border: '1px solid lightgrey', marginTop: '2rem', background: '#b4cfd1bd', display: 'flex' }}>
                                    <div className="col-md-3 p-2" style={{ paddingLeft: 'inherit' }}>
                                        <b><label for="exampleInputEmail1" class="form-label">PO Number</label></b>
                                        <Select maxMenuHeight={500} placeholder="PO Number" value={this.state.dropDownArray.find(option => option.value === this.state.selectedPOSAPId)} styles={customStyles} options={this.state.dropDownArray} onChange={(e) => this.handleSelectPOs(e)} />
                                        {this.state.err.POAsId != "" ? <p style={{ color: 'red', fontSize: '10px' }}>{this.state.err.POAsId}</p> : null}
                                    </div>
                                    <div className="col-md-3 p-2" style={{ paddingLeft: 'inherit' }}>
                                        <b><label for="exampleInputEmail1" class="form-label">BG Type</label></b>
                                        <Select maxMenuHeight={500} placeholder="Bank Guarentee Type" value={{ label: this.state.BGType }} styles={customStyles} options={this.state.BGTypeOption} onChange={(e) => this.handleSelectBGType(e)} />
                                        {this.state.err.BGtype != "" ? <p style={{ color: 'red', fontSize: '10px' }}>{this.state.err.BGtype}</p> : null}
                                    </div>
                                    <div className="col-md-3 p-2" style={{ paddingLeft: 'inherit' }}>
                                        <b><label htmlFor="fileInput" className="form-label">Choose PDF File</label></b>
                                        <input
                                            type="file"
                                            id="fileInput"
                                            // accept=".pdf"
                                            onChange={(e) => this.handlePOPDF(e)}
                                        />
                                        {this.state.err.fileerr != "" ? <p style={{ color: 'red', fontSize: '10px' }}>{this.state.err.fileerr}</p> : null}
                                    </div>
                                    <div className="col-md-3 p-2" style={{ paddingLeft: 'inherit' }}>
                                        <button className="btn2 btn-sms1 rounded-pill mt-4" disabled={this.state.loadingData == true ? true: false} onClick={() => this.uploadPOPDF()} type="submit">Submit</button>
                                    </div>
                                </div>
                            </div>
                            : null}
                        <div className="row sticky pl-5 pt-6 " style={{ justifyContent: 'left' }}>
                            <table className="table1 mt-4 ">
                                <thead className=" sticky-inner" style={{ backgroundColor: "#0989CB", color: "white" }}>
                                    <tr>
                                        <th scope="col" style={{ minWidth: '120px' }}>PO Number</th>
                                        <th scope="col" style={{ minWidth: '120px' }}>BG Type</th>
                                        <th scope="col" style={{ minWidth: '100px' }}>Uploaded by</th>
                                        <th scope="col" style={{ minWidth: '100px' }}>Created On</th>
                                        <th scope="col" style={{ minWidth: '100px' }}>Action</th>
                                       { groups[6]  ?<th scope="col" style={{ minWidth: '100px', maxWidth: '300px' }}>Comment</th>: null}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.tableData.map((item, index) => {
                                        console.log(this.state.bgStatus[item.Status]['status'], "jdfbhfhdsbjfsdfbhsd")
                                        return (
                                            <tr key={index}>
                                                <td>{item.POSAPId}</td>
                                                <td>{item.BgType}</td>
                                                <td>{item.FullName}</td>
                                                <td>{dateFormater(item.CreatedOn)}</td>
                                                <td >
                                                    <div className="row text-center headeralign">
                                                        <div className="col-sm-3">
                                                            <a href={FILESERVER_ROOT_URL + "files/Documents/" + item.DocumentID + "/download"} target="_blank" download >
                                                                < FontAwesomeIcon icon={"download"} cursor="pointer" color={"black"} title="View Info" size="lg" />
                                                            </a>
                                                        </div>
                                                        {groups[9] && (item.Status == 2 || item.Status == 0) ?
                                                            <div style={{ display: 'flex', width: '60px', justifyContent: 'space-around' }}>
                                                                <div className="col-sm-3 pl-0">
                                                                    < FontAwesomeIcon icon={"check-circle"} cursor="pointer" color={"green"} title="Approve" size="lg" onClick={() => this.modalBGActivity(item, "Drafted BG Is Approved", 1)} />
                                                                </div>
                                                                <div className="col-sm-3">
                                                                    < FontAwesomeIcon icon={"times-circle"} cursor="pointer" color={"red"} title="Reject" size="lg" onClick={() => this.modalBGActivity(item, "Drafted BG Is Reject", 3)} />
                                                                </div>
                                                            </div>
                                                            : groups[6] && (item.Status == 3 || item.Status == 1) && this.state.bgStatus[item.Status]['status'] != "Approved" ?
                                                                <div className="col-sm-3 pl-1">
                                                                    <FontAwesomeIcon cursor="pointer" icon={"history"} color={"black"} title={"Upload File"} size="lg" onClick={() => this.RevisemodalBGActivity(item, "Drafted BG Is Revise", 2)} />
                                                                </div> : null
                                                        }
                                                        <div className="col-sm-3">
                                                            < FontAwesomeIcon icon={"code-branch"} cursor="pointer" color={"black"} title="View Info" size="lg" onClick={() => this.OpenVersionModal(item.DocumentID)} />
                                                        </div>
                                                        <div className="col-sm-3 pl-1">
                                                            < FontAwesomeIcon icon={"info-circle"} cursor="pointer" color={"black"} title="View Info" size="lg" onClick={() => this.OpenInFoModal(item)} />
                                                        </div>
                                                    </div>
                                                    <div className="row text-center d-none d-sm-block headeralign">
                                                        <span className={"badge " + this.state.bgStatus[item.Status]['badge']}>
                                                            {this.state.bgStatus[item.Status]['status']}
                                                        </span>
                                                    </div>
                                                </td>
                                                {this.state.bgStatus[item.Status]['status'] == "Approved" && groups[6] ? 
                                                <td style={{maxWidth: '300px'}}>
                                                     <p>Approval Confirmed for Final Draft Bank Guarantee – Kindly Proceed with Uploading for Invoice in Purchase Order Detail Page</p>
                                                </td>: null}
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
        )
    }
}

const mapStateToProps = (state) => ({ expediting: state.expediting, bgdraftDocReducer: state.bgDraftDocReducer, filterList: state.masterReducer.filterList, poDetails: state.poDetails })
export default connect(mapStateToProps, { GetFilterList, saveBGDraftDocDetail, UpdateBgGraftDocDetail, GetBGDraftDocDetail, savePOBGDraftDocDetail, GenericUploadVersionFile, GetBgDraftDocTableData, getactionDetail, UpdatePOBGDraftDocDetail, GetPODetailDocDetail, uploadFileGeneric, getProjectAllocationByUserId })(BGDraftDoc)